<template>
  <header
    class="pt-nav relative grid grid-cols-3 bg-amber-100 pl-4 pb-4 sm:pl-20 md:min-h-[75vh]"
  >
    <!-- TITLE -->
    <div class="order-1 col-span-3 sm:col-span-2">
      <h1 class="mt-12 max-w-[16ch] text-2xl font-medium sm:mt-24 md:text-7xl">
        {{ page.title }}
      </h1>

      <!-- CATEGORIES -->
      <div
        class="order-2 col-start-1 mt-6 mb-10 flex flex-wrap gap-2 pr-10 md:mt-10"
      >
        <!-- link to mount page -->
        <div
          v-for="category in page.categories"
          :key="category.title"
          class="h-min w-fit"
        >
          <NuxtLink
            :to="{
              path: parentPageUrl,
              query: { filters: category.title },
            }"
            :aria-label="`Link zu allen Events der Kategorie ${category.title}`"
            class="rounded-full px-4 py-[0.438rem] text-2xs !leading-tight text-gray-800 ring-1 ring-gray-800/70 transition-colors focus-visible:outline focus-visible:outline-offset-4 focus-visible:outline-blue-500 sm:py-2 md:px-[1.125rem] md:py-[0.5625rem]"
          >
            {{ category.title }}
          </NuxtLink>
        </div>
      </div>
    </div>

    <!-- IMAGE -->
    <div
      class="order-3 col-span-3 overflow-hidden sm:order-2 sm:col-span-1 sm:-mb-28"
    >
      <!-- Placeholder for the coming Lottie Animation -->
      <div v-if="page.file.extension === 'json'" class="relative">
        <ClientOnly>
          <Vue3Lottie
            :animation-link="page.file.url"
            class="lottie-event-detail pointer-events-none"
          />
        </ClientOnly>
      </div>
      <AppImage
        v-else-if="page.file"
        :src="page.file"
        class="w-full object-cover"
      />
    </div>

    <!-- TEXT -->
    <div
      class="order-2 col-span-3 pb-10 pr-4 sm:order-3 sm:pr-20 sm:pb-20 md:pr-0 lg:col-span-1 lg:col-start-2 lg:mx-[-10%]"
    >
      <table class="h-min">
        <tbody>
          <tr class="border-none bg-amber-100">
            <td
              class="flex items-start justify-end pt-[0.675rem] pr-5 text-xs md:justify-start md:pt-4 md:pr-8"
            >
              Datum
            </td>
            <td class="text-[1.625rem] md:text-2xl">{{ page.event_date }}</td>
          </tr>
          <tr class="border-none bg-amber-100">
            <td
              class="flex items-start justify-end pt-[0.675rem] pr-5 text-xs md:justify-start md:pt-4 md:pr-8"
            >
              Uhrzeit
            </td>
            <td class="text-[1.625rem] md:text-2xl">{{ page.time }}</td>
          </tr>
          <tr class="border-none bg-amber-100">
            <td
              class="flex items-start justify-end pt-10 pr-5 text-xs md:justify-start md:pt-14 md:pr-8"
            >
              Ort
            </td>
            <td class="pt-7 text-[1.625rem] md:pt-10 md:text-2xl">
              {{ page.location }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </header>
</template>

<script setup>
defineProps({
  page: {
    type: Object,
    default: () => ({}),
  },
})

const route = useRoute()

// COMPUTED
const parentPageUrl = computed(() => {
  let parentUrl = route.params.uri.slice(0, -1)

  if (parentUrl.length === 0) {
    return `/${route.params.uri[0]}`
  }

  if (parentUrl.length === 1) {
    return `/${parentUrl[0]}`
  }

  return `/${parentUrl.join('/')}`
})
</script>

<style lang="scss">
.lottie-event-detail svg {
  transform: scale(1.035) translateX(5%) !important;
  margin-top: -15%;
}
</style>
